module.exports = __webpack_public_path__ + "static/L2_content_5_2_do-9f34a55efb80c476940d8c5c82c7179a.png";